import { UserModel } from './user.model';

export type FileModuleType = 'USER' | 'SUPPLIER' | 'COMPANY' | 'CARRIER' | 'USER_WARNING' | 'USER_HOUR_BANK';

export class FileModuleModel {
    file_module_id: number;

    module: FileModuleType;

    entity_id: number;

    path: string;

    type_file: string;

    name: string | null;

    user_id: number | null;

    user: UserModel | null;

    createdAt: Date;

    constructor(data?: Partial<FileModuleModel>) {
        this.file_module_id = data?.file_module_id ?? null;
        this.module = data?.module ?? null;
        this.entity_id = data?.entity_id ?? null;
        this.path = data?.path ?? null;
        this.type_file = data?.type_file ?? null;
        this.name = data?.name ?? null;
        this.user_id = data?.user_id ?? null;
        this.user = data?.user ? new UserModel(data.user) : null;
        this.createdAt = data?.createdAt ?? null;
    }
}
